<template>
    <div class="page">
        <div class="page-header">
            <h1 class="pl-5 title text-light">Información sobre Cookies</h1>
        </div>
        <main>
            <div class="container">
                <div class="row">
                    <div class="cookies-page col-12 col-md-10 mx-auto py-1">

                        <h5>1. Concepto de Cookies</h5>
                        <p> Las Cookies son ficheros que se almacenan en el ordenador o dispositivo móvil del Usuario
                            (destinatario) al navegar por Internet y que, en particular, contienen un número/clave que
                            permite identificar unívocamente el ordenador o dispositivo móvil del Usuario, aunque éste
                            cambie de localización o de dirección IP.</p>

                        <p>Las Cookies son instaladas durante la navegación por Internet, bien por los sitios web que
                            visita el Usuario o bien por terceros con los que se relaciona dicho sitio web. Las cookies
                            permiten al sitio web conocer la actividad del Usuario en su seno o en otros sitios
                            relacionados, por ejemplo: el lugar desde el que accede, el tiempo de conexión, el
                            dispositivo
                            desde el que accede (ordenador, Smartphone, tableta, televisión, …) el sistema operativo y
                            navegador utilizados, las páginas visitadas, el número de clics realizados y de datos
                            respecto
                            al comportamiento del Usuario en Internet.</p>

                        <p>Por regla general, una página o sitio web es accesible sin necesidad que las Cookies estén
                            activadas. No obstante, su desactivación puede impedir su correcto funcionamiento.</p>

                        <h5>2. ¿Qué tipos de Cookies existen?</h5>
                        <p><strong>1) Según la entidad que las gestione:</strong></p>

                        <p><strong>- Cookies propias:</strong> Son aquellas que se envían al navegador del Usuario desde
                            un equipo o dominio
                            gestionado por el propio Titular del Sitio Web y desde el que se presta el servicio
                            solicitado
                            por el Usuario.</p>

                        <p><strong>- Cookies de terceros:</strong> Son aquellas que se envían al navegador del Usuario
                            desde un equipo o
                            dominio que no es gestionado por el Titular del Sitio Web, sino por otra entidad que trata
                            los
                            datos obtenidos través de las Cookies.</p>

                        <p><strong> 2) Según el plazo de tiempo que permanecen activadas:</strong></p>
                        <p><strong>- Cookies de sesión:</strong> Son un tipo de Cookies diseñadas para recabar y
                            almacenar datos mientras el
                            Usuario accede a una página web.</p>

                        <p><strong>- Cookies persistentes:</strong> Son un tipo de Cookies en el que los datos siguen
                            almacenados en el
                            navegador y pueden ser accedidos y tratados durante un periodo definido por el editor de la
                            Cookie, y que puede ir de unos minutos a varios años.</p>

                        <p><strong>3) Según la finalidad para la que se traten los datos obtenidos a través de las
                                cookies:</strong> </p>

                        <p><strong> - Cookies de análisis (analíticas o de estadística):</strong> Son aquellas que bien
                            tratadas por el
                            Titular del Sitio Web o por terceros, permiten cuantificar el número de Usuarios y así
                            realizar
                            la medición y análisis estadístico de la utilización que hacen los usuarios del sitio web
                            y/o
                            servicio ofertado.</p>

                        <p><strong>- Cookies técnicas (de funcionamiento):</strong> Son aquéllas que permiten al Usuario
                            la navegación a
                            través de una página web, plataforma o aplicación y la utilización de las diferentes
                            opciones o
                            servicios que en ella existan como por ejemplo: controlar el tráfico y la comunicación de
                            datos,
                            identificar la sesión, realizar la solicitud de inscripción o participación en un evento,
                            utilizar elementos de seguridad durante la navegación, almacenar contenidos para la difusión
                            de
                            videos o sonido o compartir contenidos a través de redes sociales.</p>

                        <p><strong> - Cookies de personalización: </strong>Son aquéllas que permiten al Usuario acceder
                            al servicio con
                            algunas características de carácter general predefinidas en función de una serie de
                            criterios en
                            el terminal del Usuario como por ejemplo serian el idioma, el tipo de navegador a través del
                            cual accede al servicio, la configuración regional desde donde accede al servicio, etc.
                            - Cookies publicitarias: Son aquéllas que permiten la gestión, de la forma más eficaz
                            posible,
                            de los espacios publicitarios que, en su caso, el editor haya incluido en una página web,
                            aplicación o plataforma desde la que presta el servicio solicitado en base a criterios como
                            el
                            contenido editado o la frecuencia en la que se muestran los anuncios.</p>

                        <p><strong> - Cookies de publicidad comportamental (de elaboración de perfiles):</strong> Son
                            aquéllas que permiten
                            la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso,
                            el
                            editor haya incluido en una página web, aplicación o plataforma desde la que presta el
                            servicio
                            solicitado. Estas cookies almacenan información del comportamiento de los Usuarios obtenida
                            a
                            través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar
                            un
                            perfil específico para mostrar publicidad en función de este.</p>

                        <p><strong>- Cookies de acceso a redes sociales:</strong> incluyen enlaces de acceso a redes
                            sociales con la
                            finalidad de enlazar y compartir ciertos contenidos del portal, de modo que no necesite
                            introducir la información cada vez que pulse un botón de conexión.</p>

                        <h5> 3. Cookies utilizadas en este Sitio Web</h5>
                        <p>En el Panel de Configuración dispuesto al inicio de la presente Política de Cookies, se
                            describen las distintas categorías de cookies utilizadas en este sitio web según su
                            finalidad,
                            pudiendo el usuario configurarlas según sus preferencias.</p>

                        <p>El uso de Cookies nos permite facilitar la navegación del Usuario y adaptar la información y
                            los
                            servicios que ofrecemos a sus intereses. Las Cookies se usan tanto de modo permanente como
                            temporal (Cookies de sesión). Las Cookies permanentes se almacenan en su ordenador o
                            dispositivo
                            móvil durante un periodo de tiempo no superior a 24 meses.</p>

                        <h5>4. Deshabilitación de las Cookies.</h5>
                        <p> El usuario en todo momento podrá acceder a la configuración de su navegador para modificar
                            y/o
                            bloquear la instalación de las Cookies, pero ello puede implicar que algunas funcionalidades
                            queden deshabilitadas y que pueda verse limitado el acceso a algunos contenidos. La calidad
                            del
                            funcionamiento de los servicios puede verse igualmente afectada.</p>

                        <h5> 5. Configuración del navegador – Facultad de revocar el consentimiento dado</h5>
                        <p> Para permitir, conocer, bloquear o eliminar las Cookies instaladas en su equipo, el Usuario
                            puede configurar las opciones del navegador instalado en su dispositivo. Para ello el
                            Usuario
                            puede consultar la herramienta de ayuda de su navegador o acceder a las páginas web de ayuda
                            de
                            los navegadores, siendo los más habituales los siguientes:</p>

                        <p>
                            Internet Explorer: <a href="https://privacy.microsoft.com/es-es/privacystatement" target="_blank">https://privacy.microsoft.com/es-es/privacystatement</a><br>
                            Safari: <a href="https://www.apple.com/legal/privacy/es/cookies/" target="_blank">https://www.apple.com/legal/privacy/es/cookies/</a> <br>
                            Google Chrome: <a href="https://support.google.com/chrome/answer/95647?hl=es&hlrm=en" target="_blank">https://support.google.com/chrome/answer/95647?hl=es&hlrm=en</a> <br>
                            Google: <a href="https://www.google.com/intl/es/policies/privacy/" target="_blank">https://www.google.com/intl/es/policies/privacy/</a> <br>
                            Firefox: <a href="http://support.mozilla.org/es/kb/Borrar%20cookies" target="_blank">http://support.mozilla.org/es/kb/Borrar%20cookies</a> <br>
                            Opera: <a href="https://www.opera.com/es/privacy" target="_blank">https://www.opera.com/es/privacy</a> <br>
                            Android (Google): <a href="https://www.google.com/intl/es/policies/privacy/">https://www.google.com/intl/es/policies/privacy/</a> <br>
                            Windows Phone (Microsoft): <a href="https://privacy.microsoft.com/es-es/privacystatement" target="_blank">https://privacy.microsoft.com/es-es/privacystatement</a> <br>
                            Blackberry: <a href="http://global.blackberry.com/es/legal/privacy-policy.html" target="_blank">http://global.blackberry.com/es/legal/privacy-policy.html</a> <br>
                        </p>

                        <p> <strong> Importante:</strong> los navegadores pueden también cambiar sus políticas y la
                            ubicación de la
                            información sobre privacidad y uso de cookies.</p>

                        <h5>6. Actualizaciones y cambios en la Política de Cookies</h5>
                        <p>El Titular del Sitio Web puede modificar esta Política de Cookies en función de nuevas
                            exigencias legislativas, reglamentarias, o con la finalidad de adaptar dicha política a las
                            instrucciones dictadas por la Agencia Española de Protección de Datos, así como la
                            implementación o cese de uso de todas o algunas de las Cookies insertadas en el Sitio Web.
                        </p>

                        <p>Cuando se produzcan cambios significativos en esta Política de Cookies se comunicará al
                            Usuario
                            mediante un aviso informativo en la página web. No obstante, recomendamos revisar esta
                            política
                            cada vez que acceda a nuestro Sitio Web con el objetivo de estar adecuadamente informado
                            sobre
                            cómo y para qué usamos las cookies.</p>

                        <p>El Usuario siempre puede efectuar consultas sobre la Política de Cookies del Sitio Web
                            poniéndose en contacto con el Titular a través de la siguiente dirección electrónica:
                            info@edadeoro.es, indicando en el asunto "Política de Cookies".</p>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

export default {
    name: 'cookies',

    components: {
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

        //iconoStd(std) {
            //return this.estados[std];
        //}
    }
}
</script>